define(['app', './index.html'], function (app, tmpl) {
  return app.Marionette.LayoutView.extend({
    template: tmpl,

    options: {
      header: false,
      content: false,
      footer: false,
      animate: true
    },

    ui: {
      container: '.js-widget-container',
      header: '.widget__header',
      content: '.widget__content',
      footer: '.widget__footer'
    },

    regions: {
      header: '.widget__header',
      content: '.widget__content',
      footer: '.widget__footer'
    },

    renderPartial: function (region, partial) {
      if (typeof partial === 'string') {
        this.ui[region].append(partial)
      } else if (partial) {
        this.getRegion(region).show(partial)
      }
    },

    onRender: function () {
      this.renderPartial('header', this.options.header)
      this.renderPartial('content', this.options.content)
      this.renderPartial('footer', this.options.footer)

      if (this.getOption('animate')) {
        this.ui.container.slideDown(1000)
      } else {
        this.ui.container.show()
      }
    }
  })
})
